<template>
  <b-overlay
    :show="load"
    opacity="0.6"
    style="width:100%"
    @hidden="onHidden"
    class="mb-0"
  >
    <template v-slot:overlay>
      <div class="d-flex align-items-center">
        <b-spinner small type="grow" pill variant="dark"></b-spinner>
        <!-- We add an SR only text for screen readers -->
        <span class="ml-2" v-if="loadMes">{{ loadMes }}</span>
        <span class="ml-2" v-else>Chờ tí ...</span>
      </div>
    </template>
    <div
      class="form-group m-0"
      :class="[
        { 'input-group': hasIcon },
        { 'has-danger': error },
        { focused: focused },
        { 'has-label': label || $slots.label },
        { 'has-success': valid === true },
        { 'has-danger': valid === false }
      ]"
    >
      <slot name="label">
        <label v-if="label" class="form-control-label" :class="labelClasses">
          {{ label }}
          <span v-if="required">*</span>
        </label>
      </slot>

      <div v-if="addonLeftIcon || $slots.addonLeft" class="input-group-prepend">
        <span class="input-group-text">
          <slot name="addonLeft">
            <i :class="addonLeftIcon"></i>
          </slot>
        </span>
      </div>
      <slot v-bind="slotData">
        <input
          ref="input"
          :value="value"
          v-on="listeners"
          v-bind="$attrs"
          v-mask="valMask"
          :placeholder="placeholder"
          @keydown.enter="$emit('search')"
          class="form-control"
          :class="[
            { 'is-valid': valid === true },
            { 'is-invalid': valid === false },
            inputClasses
          ]"
          aria-describedby="addon-right addon-left"
        />
      </slot>
      <div
        v-if="addonRightIcon || $slots.addonRight"
        class="input-group-append"
      >
        <span class="input-group-text" @click="onRightClick">
          <slot name="addonRight">
            <i :class="addonRightIcon"></i>
          </slot>
        </span>
      </div>
      <slot name="infoBlock"></slot>
      <slot name="helpBlock">
        <div
          class="text-danger invalid-feedback"
          style="display: block; padding: 0px 5px 10px 10px; font-style: italic; opacity: 0.7;"
          :class="{ 'mt-2': hasIcon }"
          v-if="error"
        >
          {{ error }}
        </div>
      </slot>
    </div>
  </b-overlay>
</template>
<script>
export default {
  inheritAttrs: false,
  name: "base-input",
  props: {
    mask: {},
    load: {},
    loadMes: {},
    required: {
      type: Boolean,
      description: "Whether input is required (adds an asterix *)"
    },
    placeholder: {
      type: String,
      description: ""
    },
    valid: {
      type: Boolean,
      description: "Whether is valid",
      default: undefined
    },
    label: {
      type: String,
      description: "Input label (text before input)"
    },
    error: {
      type: String,
      description: "Input error (below input)"
    },
    labelClasses: {
      type: String,
      description: "Input label css classes"
    },
    inputClasses: {
      type: String,
      description: "Input css classes"
    },
    value: {
      type: [String, Number],
      description: "Input value"
    },
    addonRightIcon: {
      type: String,
      description: "Addon right icon"
    },
    addonLeftIcon: {
      type: String,
      description: "Addont left icon"
    }
  },
  data() {
    return {
      focused: false,
      valMask: ""
    };
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners,
        input: this.updateValue,
        focus: this.onFocus,
        blur: this.onBlur
      };
    },
    slotData() {
      return {
        focused: this.focused,
        ...this.listeners
      };
    },
    hasIcon() {
      const { addonRight, addonLeft } = this.$slots;
      return (
        addonRight !== undefined ||
        addonLeft !== undefined ||
        this.addonRightIcon !== undefined ||
        this.addonLeftIcon !== undefined
      );
    }
  },
  created() {
    if (this.mask == "number") {
      this.valMask = {
        alias: "decimal",
        digits: 4,
        groupSeparator: ",",
        rightAlign: true
      };
    } else {
      this.valMask = this.mask;
    }
  },
  methods: {
    updateValue(evt) {
      let value = evt.target.value;
      if (this.mask == "number") {
        value = isNaN(Number(value))
          ? Number(value.replace(/,/g, ""))
          : Number(value);
      }
      this.$emit("input", value);
    },
    onFocus(value) {
      this.focused = true;
      this.$emit("focus", value);
    },
    onBlur(value) {
      this.focused = false;
      this.$emit("blur", value);
    },
    onHidden() {
      // Return focus to the button once hidden
      this.$refs.input.focus();
    },
    onRightClick() {
      this.$emit("onRightClick");
    }
  }
};
</script>
<style></style>
